import { connect } from 'react-redux'
import { checkXiaoJia } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkXiaoJia
}
const mapStateToProps = (state) => {
  return {
    ...state.XiaoJiaCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
